<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    flat
    height="75"
  >
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />


    <v-spacer />

    <team-selector />

    <!--    <v-text-field-->
    <!--      :label="$t('search')"-->
    <!--      color="secondary"-->
    <!--      hide-details-->
    <!--      style="max-width: 165px;"-->
    <!--    >-->
    <!--      <template-->
    <!--        v-if="$vuetify.breakpoint.mdAndUp"-->
    <!--        v-slot:append-outer-->
    <!--      >-->
    <!--        <v-btn-->
    <!--          class="mt-n2"-->
    <!--          elevation="1"-->
    <!--          fab-->
    <!--          small-->
    <!--        >-->
    <!--          <v-icon>mdi-magnify</v-icon>-->
    <!--        </v-btn>-->
    <!--      </template>-->
    <!--    </v-text-field>-->

    <div class="mx-3" />

    <v-btn
      class="ml-2"
      min-width="0"
      text
      to="/"
    >
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon left>
            mdi-account-circle
          </v-icon>
          <span class="hidden-sm-and-down">{{ user.name }}</span>
        </v-btn>
      </template>

      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ user.name.toUpperCase() }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
            <v-list-item-subtitle>
              <template v-if="user.roles ? user.roles.length <= 3 : false">
                <v-chip
                  v-for="role in user.roles"
                  :key="role"
                  x-small
                  class="mr-1"
                >
                  {{ role }}
                </v-chip>
              </template>
              <template v-else>
                <v-chip
                  v-for="role in (user.roles ? user.roles.slice(0, 3) : [])"
                  :key="role"
                  x-small
                  class="mr-1"
                >
                  {{ role }}
                </v-chip>
                <v-chip
                  x-small
                  class="mr-1"
                >
                  +{{ user.roles ? user.roles.length - 3 : 0 }} more
                </v-chip>
              </template>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <template v-if="user.teams ? user.teams.length <= 3 : false">
                <v-chip
                  v-for="team in user.teams"
                  :key="team._id || team.name"
                  x-small
                  class="mr-1"
                >
                  {{ team.name }}
                </v-chip>
              </template>
              <template v-else>
                <v-chip
                  v-for="team in (user.teams ? user.teams.slice(0, 3) : [])"
                  :key="team._id || team.name"
                  x-small
                  class="mr-1"
                >
                  {{ team.name }}
                </v-chip>
                <v-chip
                  x-small
                  class="mr-1"
                >
                  +{{ user.teams ? user.teams.length - 3 : 0 }} more
                </v-chip>
              </template>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <template v-if="groups.length > 3">
                <v-chip
                  v-for="group in groups.slice(0, 3)"
                  :key="group._id || group.code || group"
                  x-small
                  class="mr-1"
                >
                  {{ group.name || group.code || group }}
                </v-chip>
                <v-chip
                  x-small
                  class="mr-1"
                >
                  +{{ groups.length - 3 }} more
                </v-chip>
              </template>
              <template v-else>
                <v-chip
                  v-for="group in groups"
                  :key="group._id || group.code || group"
                  x-small
                  class="mr-1"
                >
                  {{ group.name || group.code || group }}
                </v-chip>
              </template>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item
          to="app/pages/user"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-account-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Edit Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          link
          @click="signOut"
        >
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'
  // Utilities
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import TeamSelector from '@/views/dashboard/components/TeamSelector'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      TeamSelector,
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      notifications: [
      ],
    }),

    computed: {
      ...mapState('app', ['drawer', 'busy']),
      ...mapState(['user']),
      ...mapGetters(['groups']),
    },

    methods: {
      ...mapMutations({
        setDrawer: 'app/SET_DRAWER',
      }),
      signOut () {
        this.$store.dispatch('logout').then(() => this.$router.replace('/'))
      },
    },
  }
</script>
